import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { COLLECTION_NAMES } from '../constants/collection.const';
import { Notification } from '../models/notification.model';
import { FirestoreService, Params } from './firebase/firestore.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends FirestoreService {

  private static isInit = false;
  private _unsub = () => {};
  public notifications: BehaviorSubject<Notification[]> = new BehaviorSubject<Notification[]>([]);

  constructor() {
    super();
  }

  async setup(uid: string) {
    if(NotificationService.isInit) return;
    NotificationService.isInit = true;

    this.setSubCollection(uid);
    const params: Params = {
      limit: 20,
      orders: [{
        fieldPath: 'create_in',
        direction: 'desc'
      }]
    };

    const q = this.getQuery(params);
    this._unsub = this.onSnapshot(q, (querySnapshot) => {
      const docs = querySnapshot.docs.map((doc) => {
        return doc.data();
      });

      this.notifications.next(docs);
    });
  }

  public unsub() {
    this.notifications.next([]);
    this._unsub();
    NotificationService.isInit = false;
  }

  setSubCollection(uid) {
    this.setCollectionRef(COLLECTION_NAMES.USER);
    this.setSubCollectionRefByRef(this.getDocRef(uid), COLLECTION_NAMES.NOTIFICATION);
  }

  getOrderByDate(uid: string) {
    this.setSubCollection(uid);
    const params: Params = {
      limit: 10,
      orders: [{
        fieldPath: 'create_in',
        direction: 'desc'
      }]
    };

    return this.load(params);
  }

  markAsRead(notification: Notification) {
    this.setSubCollection(notification.uid);
    notification.update_in = new Date();

    return this.set({ read: true }, notification.id);
  }
}
